import { render, staticRenderFns } from "./DetailsInfoAlternanza.vue?vue&type=template&id=4886645a&scoped=true&"
import script from "./DetailsInfoAlternanza.vue?vue&type=script&lang=ts&"
export * from "./DetailsInfoAlternanza.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsInfoAlternanza.vue?vue&type=style&index=0&id=4886645a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886645a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCol,VDivider,VIcon,VRow,VTab,VTabItem,VTabs})
